export const SELECT_SESSIONS_PROMPT = 'Select one or more sessions to update the labels';
